// https://vuex.vuejs.org/en/getters.html

export default {
  snackText(state) {
    return state.snack.text;
  },
  snackDisplay(state) {
    return state.snack.display;
  },
  snackColor(state) {
    return state.snack.color;
  },
  loading(state) {
    return state.loading;
  }
};
